<script>
export default {
	name: 'TariffRules',
};
</script>

<template>
	<div class="container">
		<div class="tariff-rules">
			<h1 class="title fs-56 mb-40">Тарифы и правила рекуррентных платежей</h1>
			
			<div class="rules-content">
				<h2 class="fs-32 mb-20">Стоимость подписки</h2>
				<p class="fs-18 mb-30">
					Цена подписки составляет 399 рублей в месяц.
				</p>

				<h2 class="fs-32 mb-20">Периодичность списаний</h2>
				<p class="fs-18 mb-30">
					Списание средств происходит ежемесячно на автоматической основе (рекуррентные платежи).
				</p>

				<h2 class="fs-32 mb-20">Возможность отмены подписки</h2>
				<p class="fs-18 mb-20">
					Вы можете отменить свою подписку в любой момент. Для отмены подписки необходимо связаться с поддержкой клиентов.
				</p>
				<p class="fs-18 mb-30">
					Обратите внимание, что отмена подписки прекращает будущие списания, но уже списанные средства за текущий период возврату не подлежат.
				</p>

				<h2 class="fs-32 mb-20">Возврат средств</h2>
				<p class="fs-18 mb-20">
					Возврат средств возможен в случае технической ошибки со стороны сервиса или если списание было произведено по ошибке. Для оформления запроса на возврат необходимо связаться с службой поддержки и предоставить подтверждение платежа и объяснение причины возврата.
				</p>

				<h2 class="fs-32 mb-20">Контактная информация</h2>
				<div class="fs-18 mb-30">
					<p>По всем вопросам, связанным с тарифами и платежами, обращайтесь:</p>
					<p>Email: <a href="mailto:info@myvpn.com" class="text-violet">info@myvpn.com</a></p>
					<p>Telegram: <a href="https://t.me/myvpn_chat" target="_blank" class="text-violet">@myvpn_chat</a></p>
				</div>

				<div class="fs-16 text-muted mt-40">
					<p>Дата последнего обновления: {{ new Date().toLocaleDateString('ru-RU') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.tariff-rules {
	max-width: 800px;
	margin: 0 auto;
	padding: 20px;
}

.rules-content {
	line-height: 1.6;
}

.text-muted {
	color: #A6ADB8;
}

a.text-violet {
	color: #8B5CF6;
	text-decoration: underline;
}

a.text-violet:hover {
	color: #7C3AED;
}
</style>
